var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 14,
    viewBox: "0 0 44 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0409 0.44043H38.2748C37.4385 0.44043 36.7952 0.69774 36.4093 1.534L31.1344 13.5632H34.8654C34.8654 13.5632 35.5087 11.9551 35.6374 11.5691C36.0233 11.5691 39.69 11.5691 40.2046 11.5691C40.3333 12.0194 40.6549 13.4989 40.6549 13.4989H43.9999L41.0409 0.44043ZM36.6666 8.86733C36.9882 8.0954 38.0818 5.20066 38.0818 5.20066C38.0818 5.26499 38.4034 4.42873 38.5321 3.97844L38.7894 5.13634C38.7894 5.13634 39.497 8.28838 39.6257 8.93166H36.6666V8.86733Z",
    fill: "#3362AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3918 9.25194C31.3918 11.9537 28.9474 13.7549 25.1521 13.7549C23.5439 13.7549 22 13.4332 21.1638 13.0473L21.6784 10.0882L22.1287 10.2812C23.2866 10.7958 24.0585 10.9888 25.4737 10.9888C26.5029 10.9888 27.5965 10.6028 27.5965 9.70223C27.5965 9.12329 27.1462 8.73732 25.731 8.09405C24.3801 7.45077 22.579 6.42153 22.579 4.55604C22.579 1.98294 25.0877 0.246094 28.6257 0.246094C29.9766 0.246094 31.1345 0.503404 31.8421 0.825041L31.3275 3.65545L31.0702 3.39814C30.4269 3.14083 29.5907 2.88352 28.3684 2.88352C27.0176 2.94785 26.3743 3.5268 26.3743 4.04141C26.3743 4.62036 27.1462 5.07065 28.3684 5.6496C30.4269 6.61451 31.3918 7.70808 31.3918 9.25194Z",
    fill: "#3362AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.56688L0.0643275 0.30957H5.59649C6.36842 0.30957 6.94737 0.56688 7.14035 1.40314L8.36257 7.19261C7.14035 4.10489 4.30994 1.59612 0 0.56688Z",
    fill: "#F9B50B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1462 0.438351L10.5497 13.4968H6.7544L3.53802 2.56116C5.85381 4.04069 7.78364 6.35648 8.49124 7.96467L8.87721 9.31554L12.3509 0.374023H16.1462V0.438351Z",
    fill: "#3362AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6255 0.374023H21.1635L18.912 13.4968H15.374L17.6255 0.374023Z",
    fill: "#3362AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.cfb2a6a45e3c42c7c6822b36e4d8d2d1.svg";
export { ForwardRef as ReactComponent };